/**
 * ScrollTop
 * ページトップへ戻るボタン（Figma: Button_top）の表示制御。
 * トップから100pxスクロールしたら表示、100px未満に戻ったら非表示。クリックで先頭へスムーススクロール。
 *
 * @example
 * <a href="#top" class="c-totop js-totop"><span class="ico"></span><span class="label">TOP</span></a>
 */
export default class ScrollTop {
  constructor(options = {}) {
    this.el = document.querySelector(options.selector || '.js-totop');
    if (!this.el) return;

    this.threshold = options.threshold || 100;
    this.onScroll = this.onScroll.bind(this);
    this.onClick = this.onClick.bind(this);

    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.el.addEventListener('click', this.onClick);
    this.onScroll();
  }

  onScroll() {
    this.el.classList.toggle('is-visible', window.scrollY > this.threshold);
  }

  onClick(e) {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
